import { createContext, useContext, useMemo } from 'react';

const PortfolioDashboardContext = createContext(null);

/** @param {{ period: import('./portfolioDashboard.types').PortfolioPeriod, isTodaySelected: boolean, children: import('react').ReactNode }} props */
export const PortfolioDashboardProvider = function PortfolioDashboardProvider({ period, isTodaySelected, children }) {
    const value = useMemo(() => ({ period, isTodaySelected }), [period, isTodaySelected]);

    return (
        <PortfolioDashboardContext.Provider value={value}>
            {children}
        </PortfolioDashboardContext.Provider>
    );
};

/** @returns {{ period: import('./portfolioDashboard.types').PortfolioPeriod, isTodaySelected: boolean }} */
export function usePortfolioDashboard() {
    return useContext(PortfolioDashboardContext);
}
